import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="checklists" pageTitle="Checklists" pageDescription="Practical compliance checklists for regulatory, quality, and validation projects across pharma, biotech, medical devices, and IVD." showAssessments />;

export const Route = createFileRoute("/en/downloads/checklists/")({
  head: () => buildRouteHead("/en/downloads/checklists", {
    title: "Life Sciences Compliance Checklists | QbD Group",
    description: "Download practical compliance checklists on MDR, ISO 13485, 21 CFR Part 11, Annex 11 and more, built by QbD Group experts.",
  }),
  component: ContentListingRoute,
});
